var map = {
	"./bubbles/data-fingertips-full-size.png": 8170,
	"./bubbles/execute-recall.png": 1916,
	"./bubbles/fifo-lot-tracing-full-size.png": 5989,
	"./bubbles/multi-user-access.png": 5931,
	"./bubbles/po.png": 941,
	"./bubbles/production-planning-full-size.png": 6158,
	"./bubbles/track-inventory-and-cash-full-size.png": 9978,
	"./hero-illustration.svg": 5699,
	"./testimonials/enrico-biscotti-alpha.png": 6826,
	"./testimonials/frozen-garden-alpha.png": 3909,
	"./testimonials/pie-in-the-sky-alpha.png": 2089,
	"./testimonials/pops-alpha.png": 8228,
	"./testimonials/the-grass-feather-alpha.png": 7893,
	"./testimonials/virginia-chutney-alpha.png": 1239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8663;